import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Template, Button } from 'devextreme-react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import { formatMessage } from 'devextreme/localization';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import columnDataGrid from './columnDataGrid';

import DataGridMVP from '../DataGridMVP';
import styles from './responsibleperson.module.scss';
import PopupMVP from '../PopupMVP';
import SettingsStock from './SettingsStock';

import AcceptanceMetric from './AcceptanceMetric';
import ActivityMetric from './ActivityMetric';

import AddedStocks from './AddedStocks';
import AdminTabList from '../AdminTabList';

import ConfigureStock from './ConfigureStock';

import StockConfigure from './StockConfigure';
import UserManualTab from '../UserManualTab';
import SurveyTab from './SurveyTab';

const ResponsiblePerson = ({
  plantId,
  responsiblePersonReducer: {
    loading,
    listPersonsOnStock,
    loadingDel,
    isRestDelOk
  },
  stockReducer: { storageTime },
  userReducer: { permissions },
  tabsReducer: { tabSelect },
  getResponsiblePersonsOnStock,
  modalResponsiblePersonsOnStockOpen,
  delResponsiblePersonOnStock,
  getSettingsPlantStorageTime,
  shippingType
}) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [visiblePopupDel, setVisiblePopupDel] = useState(false);
  const [plantSignerId, setPlantSignerId] = useState(null);

  const [listPermissions, setListPermissions] = useState([]);

  useEffect(() => {
    if (permissions && permissions.length) {
      setListPermissions(permissions);
      if (permissions.indexOf('btnUserAdmin') !== -1) {
        if (permissions.indexOf('btnSesAdmin') === -1) {
          setSelectedIndex(2);
        } else {
          setSelectedIndex(1);
        }
      }
    }
  }, [permissions]);

  useEffect(() => {
    if (tabSelect === 5 && selectedIndex > 0) {
      if (selectedIndex !== 6) {
        getResponsiblePersonsOnStock({ plantId });
      }
      if (plantId && selectedIndex === 1) {
        getSettingsPlantStorageTime({ plant: plantId });
      }
    }
  }, [
    tabSelect,
    permissions,
    getResponsiblePersonsOnStock,
    getSettingsPlantStorageTime,
    plantId,
    selectedIndex
  ]);
  useEffect(() => {
    if (isRestDelOk) {
      setVisiblePopupDel(false);
    }
  }, [isRestDelOk]);
  const onHiding = useCallback(() => {
    setVisiblePopupDel(false);
  }, []);

  const onDel = useCallback(() => {
    delResponsiblePersonOnStock({
      plantId,
      plantSignerId
    });
  }, [delResponsiblePersonOnStock, plantId, plantSignerId]);

  // Работа с Ответственными лицами
  const toolbarButtonAddResponsiblePerson = useCallback(
    () => (
      <Button
        type="default"
        stylingMode="contained"
        icon="plus"
        text="Добавить"
        elementAttr={{ class: styles.buttonAddResponsiblePerson }}
        onClick={() => modalResponsiblePersonsOnStockOpen()}
      />
    ),
    [modalResponsiblePersonsOnStockOpen]
  );

  const renderButtonDel = useCallback(
    (data) => (
      <Button
        type="default"
        stylingMode="text"
        icon="trash"
        onClick={() => {
          setPlantSignerId(data.data.plantSignerId);
          setVisiblePopupDel(true);
        }}
      />
    ),
    []
  );

  const renderDataGridResponsiblePerson = useMemo(
    () => () => (
      <DataGridMVP
        className="shipment"
        setStateStoringName="dataGridResponsiblePerson"
        keyExpr="signerId"
        setDataGridInstance={() => {}}
        visibleButtonDateRangePicker={false}
        visibleSummary={false}
        visibleGroupPanel={false}
        visibleInfoIcon={false}
        visibleButtonAddResponsiblePerson
        dataSource={listPersonsOnStock}
        loadingData={loading}
        filterDataGrid
      >
        {columnDataGrid.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch={false}
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        <Column cellRender={renderButtonDel} width={100} />
        <Template
          name="toolbarButtonAddResponsiblePerson"
          render={toolbarButtonAddResponsiblePerson}
        />
      </DataGridMVP>
    ),
    [
      listPersonsOnStock,
      loading,
      renderButtonDel,
      toolbarButtonAddResponsiblePerson
    ]
  );

  const onSelectionChanged = useCallback(({ name, value }) => {
    if (name === 'selectedIndex') {
      setSelectedIndex(value);
    }
  }, []);
  const itemTitleRender = useCallback((item) => <span>{item.name}</span>, []);

  const settingsStock = useMemo(
    () => () => <SettingsStock plantId={plantId} shippingType={shippingType} />,
    [plantId, shippingType]
  );

  const adminTabList = useMemo(() => () => <AdminTabList plantId={plantId} />, [
    plantId
  ]);

  const acceptanceMetric = useMemo(() => () => <AcceptanceMetric />, []);
  const activityMetric = useMemo(() => () => <ActivityMetric />, []);

  const addedStocks = useMemo(() => () => <AddedStocks />, []);
  const configureStock = useMemo(
    () => () => <ConfigureStock plantId={plantId} />,
    [plantId]
  );
  const stockConfigure = useMemo(
    () => () => <StockConfigure plantId={plantId} />,
    [plantId]
  );

  const userManualTab = useMemo(
    () => () => <UserManualTab plantId={plantId} />,
    [plantId]
  );

  const surveyTab = useMemo(
    () => () => <SurveyTab />,
    []
  );

  return (
    <>
      <div className={styles.containing}>
        <TabPanel
          selectedIndex={selectedIndex}
          onOptionChanged={onSelectionChanged}
          itemTitleRender={itemTitleRender}
          elementAttr={{ class: styles.tabs }}
        >
          <Item
            tabComponent={() => <span>Ответственные</span>}
            render={renderDataGridResponsiblePerson}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Настройки</span>}
            render={settingsStock}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Администрирование</span>}
            render={adminTabList}
            disabled={listPermissions.indexOf('btnUserAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Метрика приемки</span>}
            render={acceptanceMetric}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Метрика активности</span>}
            render={activityMetric}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Подключенные склады</span>}
            render={addedStocks}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Конфигуратор</span>}
            render={configureStock}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>Конфигуратор склада</span>}
            render={stockConfigure}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>{formatMessage('textTabUserManual')}</span>}
            render={userManualTab}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
          <Item
            tabComponent={() => <span>{formatMessage('textSurveyTab')}</span>}
            render={surveyTab}
            disabled={listPermissions.indexOf('btnSesAdmin') === -1}
          />
        </TabPanel>
      </div>
      <PopupMVP
        visible={visiblePopupDel}
        onHiding={onHiding}
        title="Удалить запись?"
      >
        <div className="formData">
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={onHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={200}
              onClick={onDel}
            >
              <LoadIndicator className="indicator" visible={loadingDel} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
    </>
  );
};

export default React.memo(ResponsiblePerson);
